import { gql } from '@apollo/client';

export const START_SURVEY_EXECUTION = gql`
  mutation startSurveyExecution(
    $code: String!
    $fingerprint: SurveyFingerprint!
  ) {
    startSurveyExecution(code: $code, fingerprint: $fingerprint) {
      hash
    }
  }
`;

export const ADD_SURVEY_RESPONSE = gql`
  mutation addSurveyResponse(
    $hash: String!
    $datasheetQuestionId: Int!
    $result: String!
    $isFinished: Boolean!
    $responseTime: Int!
    $removeResultQuestionIds: [Int!]
  ) {
    addSurveyResponse(
      hash: $hash
      datasheetQuestionId: $datasheetQuestionId
      result: $result
      isFinished: $isFinished
      responseTime: $responseTime
      removeResultQuestionIds: $removeResultQuestionIds
    ) {
      success
    }
  }
`;

export const OVERRIDE_SURVEY_RESPONSE_TYPE = gql`
  mutation overrideSurveyResponseType(
    $surveyResponseId: Int!
    $responseType: SurveyResponseType!
    $comment: String!
  ) {
    overrideSurveyResponseType(
      surveyResponseId: $surveyResponseId
      responseType: $responseType
      comment: $comment
    ) {
      id
      responseType
      invalidFalsificationRules
      manualOverridenTypeComment
    }
  }
`;

export const GENERATE_DATA_FALSIFICATION_EXCEL = gql`
  mutation generateDataFalsificationExcel(
  	$jobId: Int!
  	$datasheetVersionId: Int!
  ) {
  	generateDataFalsificationExcel(
  		jobId: $jobId
  		datasheetVersionId: $datasheetVersionId
  	)
  }
`;
